import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CellContent, CellWithoutDataContent, EllipsisText } from './../styles';
import Input from '../StyledMaskedInput';

const TextInput = ({
  value: propValue = '',
  editable: propEditable = false,
  type,
  onChange,
  left,
  isMissing = false
}) => {
  const [value, setValue] = useState(propValue);
  const [initialValue, setInitialValue] = useState(propValue);
  const [editable, setEditable] = useState(propEditable);

  useEffect(() => {
    if (propValue !== initialValue && !propEditable) {
      setValue(propValue);
      setInitialValue(propValue);
      setEditable(false);
    }
  }, [propValue, propEditable, initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = (e) => {
    const newValue = e.target.value;
    setEditable(false);
    if (onChange && newValue !== initialValue) {
      onChange(newValue);
    }
  };

  const check = () => {
    setEditable(false);
    if (onChange) {
      onChange(value);
    }
  };

  const edit = () => {
    setEditable(true);
  };

  return (
    <>
      {editable ? (
        <CellContent>
          <Input
            value={value}
            onChange={handleChange}
            type={type}
            autoFocus
            onPressEnter={check}
            onBlur={handleBlur}
            left={left}
          />
        </CellContent>
      ) : (
        <>
          {value ? (
            <EllipsisText left={left} onClick={edit}> {value} </EllipsisText>
          ) : (
            <CellWithoutDataContent left={left} onClick={edit} isMissing={isMissing} />
          )}
        </>
      )}
    </>
  );
};


TextInput.propTypes = {
  value: PropTypes.string,
  editable: PropTypes.bool,
  type: PropTypes.string,
  onChange: PropTypes.func,
  left: PropTypes.bool,
};

TextInput.defaultProps = {
  value: '',
  editable: false,
  type: 'text',
  onChange: null,
  left: false,
};

export default TextInput;
